/**
 * Disable scrollbar on document.body
 * Returns a function to enable it back
 */
export function scrollLock() {
    var _a = document.body.style, bodyOverflow = _a.overflow, inlineBodyMarginRight = _a.marginRight;
    var marginLeft = document.defaultView.getComputedStyle(document.body).marginLeft;
    var marginLeftPx = parseInt(marginLeft, 10);
    var bodyOffsetRight = document.defaultView.innerWidth - document.body.offsetWidth - marginLeftPx;
    document.body.style.overflow = 'hidden';
    document.body.style.marginRight = "".concat(bodyOffsetRight, "px");
    return function () {
        document.body.style.overflow = bodyOverflow;
        document.body.style.marginRight = inlineBodyMarginRight;
    };
}
